/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, EventEmitter, Output } from '@angular/core';
import { I18nService } from '@dm/core';
import { ProductConfig } from 'app/config';

@Component({
    selector: 'app-nas-resource',
    templateUrl: './nas-resource.component.html',
    styleUrls: ['./nas-resource.component.scss'],
})
export class NasResourceComponent {
    @Output() selectedResource: EventEmitter<string> = new EventEmitter();
    isJa = this.i18n.language === 'ja';

    ProductConfig = ProductConfig;

    constructor(public i18n: I18nService) {
    }

    handleSelectedResource(type: string): void {
        this.selectedResource.emit(type);
    }
}
